module.exports = __webpack_public_path__ + "img/pro_five_4.7104a019.jpg";